/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import styled from "styled-components";

import {
  useCheckMobileView,
  WealthyEnv
} from "helpers";

const advisorImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-exclusive-webinars-savant-image.webp`;

const buttonArrow = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-button-right-arrow.svg`;


const ExclusiveWebinar = () => {
  const isMobileView = useCheckMobileView();

  return (
    <>
      {
        isMobileView ? (
          <Wrapper id="book-webinar">
            <CardWrapper>
              <TextWrapper>
                <Title>Exclusive Webinars</Title>
                <AdvisorImage>
                  <img alt="advisor-image-webinar" className="advisor-image" loading="lazy" src={advisorImage} />
                </AdvisorImage>
                <Content>
                  Attend our Webinar to learn
                  How you can start your Journey as a Wealthy Partner<br /><br />
                  with <span className="advisor-name">Chandan Savant,</span> Sr.V.P, Wealthy
                </Content>
                <BookYourSeatButton href="#register">
                  Book your seat
                  <img alt="right-arrow-icon" className="button-arrow" loading="lazy" src={buttonArrow} />
                </BookYourSeatButton>
              </TextWrapper>
            </CardWrapper>
          </Wrapper>
        ) : (
          <Wrapper id="book-webinar">
            <CardWrapper>
              <AdvisorImage>
                <img  alt="advisor-image-webinar" className="advisor-image" loading="lazy" src={advisorImage} />
              </AdvisorImage>
              <TextWrapper>
                <Title>Exclusive Webinars</Title>
                <Content>
                  Attend our Webinar to learn How you can start your Journey as a Wealthy Partner<br /><br />
                  with <span className="advisor-name">Chandan Savant,</span> Sr.V.P, Wealthy
                </Content>
                <BookYourSeatButton href="#register">
                  Book your seat
                  <img alt="right-arrow-icon" className="button-arrow" loading="lazy" src={buttonArrow} />
                </BookYourSeatButton>
              </TextWrapper>
            </CardWrapper>
          </Wrapper>
        )
      }
    </>
  );
};

const Wrapper = styled.div`
  padding: 5rem 0;
  background-color: #fff;
`;

const CardWrapper = styled.div`
  width: 85%;
  margin: auto;
  background-color: #ffcba5;
  display: flex;
  border-radius: 2.4rem;
  justify-content: space-around;
  padding-right: 10rem;

  @media (max-width: 768px) {
    width: 90%;
    padding: 5rem 2rem;
    flex-direction: column;
  }
`;

const AdvisorImage = styled.div`
  padding: 0;
  .advisor-image {
    padding: 0;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 85%;
    margin: 2rem auto;
  }
`;

const TextWrapper = styled.div`
  margin-top: 8rem;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

const Title = styled.h3`
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    text-align: center;
  }
`;

const Content = styled.p`
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;
  margin: 2rem 0 1.4rem 0;
  max-width: 420px;
  line-height: 1.8;

  .advisor-name {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    line-height: 1.8;
    text-align: center;
  }
`;

const BookYourSeatButton = styled.a`
  width: 18rem;
  height: 5.6rem;
  margin-top: 4rem;
  border-radius: 1.2rem;
  background-color: #6725f4;
  font-size: 1.8rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .button-arrow {
    vertical-align: middle;
    margin-left: 1rem;
    :hover {
      transition: all 300ms cubic-bezier(0.46,0.03,0.52,0.96);
      transform: rotate(360deg);
    }
  }

  :hover {
    transition: all 600ms cubic-bezier(0.46,0.03,0.52,0.96);
    transform: scale(1.02);
  }

  @media (max-width: 768px) {
    margin: 4rem auto 0;
    display: flex;
  }
`;

export default ExclusiveWebinar;
